import {
  Box,
  HStack,
  Skeleton,
  SkeletonCircle,
  Stack,
  VStack,
} from "@chakra-ui/react";
import React from "react";

function SkeletonAgentData() {
  return (
    <HStack gap="2" p={2}>
      <SkeletonCircle size="4" />
      <Stack flex="1">
        <Skeleton height="4" />
      </Stack>
    </HStack>
  );
}

function PromptSkeletonAgentData() {
  const listNumber = Array(5).fill(0);
  return (
    <>
      {listNumber?.map((ele) => (
        <SkeletonAgentData />
      ))}
    </>
  );
}

export default PromptSkeletonAgentData;
